
import { Vue, Options } from "vue-class-component";
import { Ref } from "vue-property-decorator";
import { DepartmentHierarchy, Department } from "../../autogen";
import Page from "../molecules/Page.vue";
import ActionButton from "../atoms/ActionButton.vue";
import Table from "../molecules/Table.vue";
import UIkit from "uikit";
import DepartmentForm from "../organisms/DepartmentForm.vue";
import Tree from "../../components/molecules/tree/Tree.vue";
import Store from "../../store";
import { NodeData } from "@/components/molecules/tree/interface";

@Options({
  components: {
    Page,
    ActionButton,
    Table,
    DepartmentForm,
    Tree
  }
})
export default class Departments extends Vue {
  private readonly storeInstance = Store.getInstance();
  departments: DepartmentHierarchy[] = [];
  department: Department | null = null;
  parents: NodeData | null = null;
  _nodePaths: { id: string; name: string }[] = [];
  nodePaths: { id: string; name: string }[] = [];
  formKey = 0;
  header = [
    { title: "部署名", sortable: true, key: "name", width: "expand" },
    { title: "編集", type: "button", key: "edit", width: 150 }
  ];
  filterColumns = ["name"];
  @Ref("modal") modal!: HTMLElement;
  @Ref("form") form!: HTMLElement;
  query = "";
  treeStyles = {
    tree: {
      style: {
        width: "100%",
        height: "auto",
        paddingLeft: "0",
        maxHeight: "unset",
        overflowY: "visible",
        textAlign: "left"
      }
    }
  };

  customOptions = {
    treeEvents: {
      expanded: {
        state: true
      },
      collapsed: {
        state: false
      },
      selected: {
        state: false
      },
      checked: {
        state: true
      }
    },
    events: {
      editableName: {
        state: true,
        calledEvent: "expanded"
      }
    },
    showTags: false,
    // Control node opening and closing with a click
    clickToggleAction: true,
    // Node click emit event. If this flag is true then clickToggleAction is convert to false
    clickNodeEvent: false
  };

  private async loadData() {
    await this.storeInstance.getDepartmentsApi({ aim: "all" });
    [this.departments, this._nodePaths] = this.storeInstance.getDepartmentHierarchy({
      visibilityMyself: false,
      withoutAll: true
    });
    this._nodePaths.unshift({ id: "none", name: "なし" });
  }
  async beforeMount() {
    await this.loadData();
  }
  onAddButtonClick() {
    this.nodePaths = this._nodePaths;
    this.formKey = Date.now();
    this.department = null;
    UIkit.modal(this.modal).show();
  }
  async onSubmitted() {
    UIkit.modal(this.modal).hide();
    await this.loadData();
  }
  onColumnClick(location: { row: number; col: string }) {}
  /**
   * Ckick edit button on department dispaly
   * @param {Department} 編集する部署オブジェクト
   * @param {NodeData} 親ノードオブジェクト
   */
  async onChangeButton(department: Department, parentNode: NodeData) {
    this.department = department;
    this.parents = parentNode;
    this.nodePaths = this._nodePaths.filter(dep => dep.name.match(RegExp(`^(?!.*${department.name}).*$`)));

    this.formKey = Date.now();
    UIkit.modal(this.modal).show();
  }
}
